module.exports = __webpack_public_path__ + "img/client10.d913f227.png";